<template>
  <div class="full-screen" style="z-index: 10;">
    <!-- <div class="header-nav">
      <div class="left">
        <a class="lk-back" @click="returnPage">返回</a>
      </div>
    </div> -->
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">登录</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>


    <div class="login">
      <h2><img src="../../../assets/images/logo.png"></h2>
      <ul>
        <li>
          <label>账号/手机号</label>
          <div><input v-model="account" class="inp" type="text" placeholder="请输入手机号或账号"/></div>
        </li>
        <li>
          <label>密码</label>
          <div><input v-model="password" class="inp" type="password" placeholder="请输入密码"/></div>
        </li>
      </ul>

      <!-- 下面是错误提示 -->
      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" @click="validate">登录</button>
      </div>
    </div>

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>登录成功</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="hideModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userService from "../../../services/userService";

  export default {
    name: "login",
    data() {
      return {
        account: '',
        password: '',
        errorMsg: {
          show: false,
          msg: ''
        },
        showModal: false
      }
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      },
      validate() {
        if (this.account === '') {
          this.errorMsg = {show: true, msg: '请输入手机号'}
        } else if (this.password === '') {
          this.errorMsg = {show: true, msg: '请输入密码'}
        } else {
          this.login();
        }
      },
      login() {
        userService.login(this.account, this.password)
          .then(res => {
            if (res.result) {
              this.showModal = true;
            } else {
              this.errorMsg = {show: true, msg: '账户或密码不正确'}
            }
          })
      },
      hideModal() {
        let obj = document.getElementById('confirm-modal');
        obj.style.opacity = 1;
        this.slideOut(obj);
      },
      slideOut(obj) {
        obj.style.opacity -= 0.05;
        if (obj.style.opacity > 0) {
          setTimeout(() => {
            this.slideOut(obj)
          }, 15)
        } else {
          this.showModal = false;
          this.$router.isBack = false;
          this.$router.push('/user');
        }
      }
    },
    mounted() {
      this.$router.isBack = true;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/login.vue